import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './Store';
import Dashboard from './components/Kyc/Dashboard/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import DocumentDetail from './components/Kyc/DocumentDetails/DocumentDetail';
import DocumentCompletion from './components/Kyc/DocumentCompletion/DocumentCompletion';
import Login from './components/Login/Login';
import OnboardingBasicDetails from './components/Onboarding/OnboardingBasicDetails/OnboardingBasicDetails';
import MappingCommission from './components/Onboarding/OnboardingBasicDetails/MappingCommission/MappingCommission';
import Status from './components/NavbarBox/Status';
import CreateRole from './components/Onboarding/OnboardingBasicDetails/CreateRole';
import UserProfile from './components/Onboarding/UserProfile/userprofile';
import OnboardingPending from './components/Onboarding/OnboardingPending/OnboardingPending';
import OnboardingCompleted from "./components/Onboarding/OnboardingCompleted/OnboardingComplete"
import OnboardingRejeceted from "./components/Onboarding/OnboardingRejeceted/OnboardingRejeceted"
import AepsDashboard from './components/Aeps/AepsDashboard';
import AespTxn from './components/Aeps/AespTxn';
import AepsMerchantdetails from './components/Aeps/AepsMerchantdetails';
import AespsReport from './components/Aeps/AespsReport';
import MerchantEdit from './components/Onboarding/SuperOnboarding/MerchantEdit';
import MappingChnage from './components/Onboarding/SuperOnboarding/MappingChnage';
import AddBankRequest from './components/Aeps/AddBankRequest';
import SettelTxn from './components/Aeps/SettelTxn';
import SettelReport from './components/Aeps/SettelReport';
import DeleteAccount from './components/Aeps/DeleteAccount';
import Lienamount from './components/Aeps/Lienamount';
import CreateRoleAdmin from './components/Onboarding/OnboardingBasicDetails/CreateRoleAdmin';
// import MerchantTopup from './components/Onboarding/MerchantToup/MerchantTopup';
// import TransactionsReport from './components/Onboarding/SuperOnboarding/Transactionsreport';
import AutoLogout from './components/Autologout/AutoLogout';
import MerchantList from './components/Onboarding/SuperOnboarding/Merchantlist';
import Rmdashboard from './components/Onboarding/Regional/RmDashboard';
import Hierarchyshow from './components/Onboarding/Regional/Hierarchy/Hierarchy';
import Shdashboard from './components/Onboarding/StateHead/ShDashboard';
import HierarchyShshow from './components/Onboarding/StateHead/HierarchySh/ShHierarchy';
import Asmdashboard from './components/Onboarding/Asm/AsmDashboard';
import AsmHierarchyShshow from './components/Onboarding/Asm/HierarchyAsm/AsmHierarchy';
import ResetPassword from './components/Onboarding/SuperOnboarding/ResetPassword/ResetPassword';
import AdminHierarchyTreeTable from './components/Onboarding/Admin/AdminHierarchy';
import ZhDashboard from './components/Onboarding/ZonalHead/ZhDashboard';
import ZhHierarchy from './components/Onboarding/ZonalHead/ZhHierarchy';
import RsmDashboard from './components/Onboarding/Rsm/RsmDashboard';
import RsmHierarchy from './components/Onboarding/Rsm/RsmHierarchy';
import CreateDummyRole from './components/Onboarding/OnboardingBasicDetails/CreateDummyRole';
import CashInTabs from './components/Onboarding/MerchantToup/CashInTabs';
import MerchantWallet from './components/Onboarding/MerchantWalletBalance/MerchantWallet';
import SearchUser from './components/Onboarding/SearchUser/SerchUser';
// import LedgerReport from './components/Onboarding/SuperOnboarding/LedgerReport';
import AllUser from './components/Onboarding/SuperOnboarding/Alluser';
import Bankdetails from './components/Onboarding/SuperOnboarding/Bankdetails';
import TransactionsReport1 from './components/Onboarding/SuperOnboarding/Transactionsreport1';
import MainRouting from './components/Onboarding/SuperOnboarding/Routing/Routing';
import PayoutAccountingDashboard from './components/Onboarding/PayoutAccounting/PayoutAccountingDashboard';
import MerchantBankApprove from './components/Kyc/MerchantBankApprove/BankApprove';
import RateSystem from './components/Onboarding/SuperOnboarding/RateSystem/RateSystem';
// import { Upload } from 'lucide-react';
import Upload from './components/bulkupload/Upload';

import UploadInvoice from './components/Onboarding/UploadInvoice/UploadInvoice';
import OdAdminHistory from './components/Onboarding/SuperOnboarding/OdAdminHistory';
import AccountingDashboard from './components/Onboarding/Accounting/AccountingDashboard';
import MerchantTopupTable from './components/Onboarding/MerchantToup/MerchantTopupTable';

import MerchantLedger from './components/Onboarding/SuperOnboarding/MerchantLedger/MerchantLedger';
import LienLedger from './components/Onboarding/SuperOnboarding/LienLedger/LienLedger';
import CdmLedger from './components/Onboarding/SuperOnboarding/CdmLedger/CdmLedger';
import CdmHistory from './components/Onboarding/SuperOnboarding/CdmLedger/CdmHistory';
import OdOutstanding from './components/Onboarding/SuperOnboarding/OdOutstanding/OdOutstanding';
import Announcement from './components/Onboarding/SuperOnboarding/Announcement/Announcement';
import AccountingRoleDashboard from './components/AccountRole/AccountRole';
import AppVersionConfig from './components/Onboarding/SuperOnboarding/AppVersionConfig/AppVersionConfig';
import Txndetails from './components/Txndetails';
import ResetMpin from './components/Onboarding/ResetMpin/ResetMpin';
import DormantUser from './components/Onboarding/SuperOnboarding/DormantUser/DormantUser';

import { useDevToolsDetector } from './components/CustomHooks/useDevToolsDetector';

function AppContent() {
  // useDevToolsDetector();

  return (
    <>
      <Routes>
        <Route path="/health" element={<Status />} />
        <Route path="/health/liveness" element={<Status />} />
        <Route path="/health/readiness" element={<Status />} />
        <Route path="/" element={<Login />} />
        <Route path="/OnboardingPending" element={<PrivateRoute element={OnboardingPending} withLayout={true} />} />
        <Route path="/OnboardingComplete" element={<PrivateRoute element={OnboardingCompleted} withLayout={true} />} />
        <Route path="/OnboardingRejeceted" element={<PrivateRoute element={OnboardingRejeceted} withLayout={true} />} />
        <Route path="/totalcount" element={<PrivateRoute element={UserProfile} withLayout={true} />} />
        <Route path="/mappingCommission" element={<PrivateRoute element={MappingCommission} withLayout={true} />} />
        <Route path="/merchnatedit" element={<PrivateRoute element={MerchantEdit} withLayout={true} />} />
        <Route path="/mappingchnage" element={<PrivateRoute element={MappingChnage} withLayout={true} />} />
        <Route path="/createrole" element={<PrivateRoute element={CreateRole} withLayout={true} />} />
        <Route path="/createroleadmin" element={<PrivateRoute element={CreateRoleAdmin} withLayout={true} />} />
        <Route path="/merchanttopup" element={<PrivateRoute element={CashInTabs} withLayout={true} />} />
        <Route path="/cashinreport" element={<PrivateRoute element={MerchantTopupTable} withLayout={true} />} />
        <Route path="/merchantwallet" element={<PrivateRoute element={MerchantWallet} withLayout={true} />} />
        <Route path="/searchuser" element={<PrivateRoute element={SearchUser} withLayout={true} />} />
        <Route path="/alluser" element={<PrivateRoute element={AllUser} withLayout={true} />} />
        <Route path="/bankdetails" element={<PrivateRoute element={Bankdetails} withLayout={true} />} />
        <Route path="/routing" element={<PrivateRoute element={MainRouting} withLayout={true} />} />
        {/* <Route path="/mappingCommission" element={<MappingCommission />} /> */}
        <Route path="/OnboardingBasicDetails" element={<PrivateRoute element={OnboardingBasicDetails} withLayout={true} />} />
        {/* <Route path="/OnboardingBasicDetails" element={<OnboardingBasicDetails /> } /> */}
        <Route path="/kycdashboard" element={<PrivateRoute element={Dashboard} withLayout={true} />} />
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route path="/document-detail" element={<PrivateRoute element={DocumentDetail} withLayout={true} />} />
        {/* <Route path="/document-detail" element={<DocumentDetail />} /> */}
        <Route path="/document-completion" element={<PrivateRoute element={DocumentCompletion} withLayout={true} />} />
        {/* <Route path="/transactionsreport" element={<PrivateRoute element={TransactionsReport} withLayout={true} />} /> */}
        <Route path="/transactionsreport1" element={<PrivateRoute element={TransactionsReport1} withLayout={true} />} />
        <Route path="/merchantlist" element={<PrivateRoute element={MerchantList} withLayout={true} />} />
        {/* <Route path="/resetpassword" element={<PrivateRoute element={ResetPassword} withLayout={true} />} /> */}
        <Route path="/createdummyrole" element={<PrivateRoute element={CreateDummyRole} withLayout={true} />} />
        <Route path="/allmerchantledger" element={<PrivateRoute element={MerchantLedger} withLayout={true} />} />
       
        <Route path="/qrupload" element={<PrivateRoute element={Upload} withLayout={true} />} />


        {/* Aesps Routes*/}

        <Route path="/aespdashboard" element={<PrivateRoute element={AepsDashboard} withLayout={true} />} />
        <Route path="/aepstxn" element={<PrivateRoute element={AespTxn} withLayout={true} />} />
        <Route path="/aepsmerchantdetails" element={<PrivateRoute element={AepsMerchantdetails} withLayout={true} />} />
        <Route path="/aepsreport" element={<PrivateRoute element={AespsReport} withLayout={true} />} />
        <Route path="/aepsbankaddrequest" element={<PrivateRoute element={AddBankRequest} withLayout={true} />} />
        <Route path="/aepssettletxn" element={<PrivateRoute element={SettelTxn} withLayout={true} />} />
        <Route path="/aepssettlereport" element={<PrivateRoute element={SettelReport} withLayout={true} />} />
        <Route path="/deleteaccount" element={<PrivateRoute element={DeleteAccount} withLayout={true} />} />
        <Route path="/lienamount" element={<PrivateRoute element={Lienamount} withLayout={true} />} />



        {/* Admin routes */}

        <Route path='/adminhierarchy' element={<PrivateRoute element={AdminHierarchyTreeTable} withLayout={true} />} />
        {/* Rm Routes */}

        <Route path='/rbdashboard' element={<PrivateRoute element={Rmdashboard} withLayout={true} />} />
        <Route path='/hierarchy' element={<PrivateRoute element={Hierarchyshow} withLayout={true} />} />

           {/* ZH Routes */}

        <Route path='/zhdashboard' element={<PrivateRoute element={ZhDashboard} withLayout={true} />} />
        <Route path='/zhhierarchy' element={<PrivateRoute element={ZhHierarchy} withLayout={true} />} />


           {/* RSM Routes */}

        <Route path='/rsmdashboard' element={<PrivateRoute element={RsmDashboard} withLayout={true} />} />
        <Route path='/rsmhierarchy' element={<PrivateRoute element={RsmHierarchy} withLayout={true} />} />

        {/* SH Routes */}

        <Route path='/shdashboard' element={<PrivateRoute element={Shdashboard} withLayout={true} />} />
        <Route path='/hierarchysh' element={<PrivateRoute element={HierarchyShshow} withLayout={true} />} />

        {/* Asm Routes */}

        <Route path='/asmdashboard' element={<PrivateRoute element={Asmdashboard} withLayout={true} />} />
        <Route path='/hierarchyasm' element={<PrivateRoute element={AsmHierarchyShshow} withLayout={true} />} />
        {/* payout accounting  */}
        <Route path='/payoutdashboard' element={<PrivateRoute element={PayoutAccountingDashboard} withLayout={true} />} />

        {/* accounting  */}
        <Route path='/accountdashboard' element={<PrivateRoute element={AccountingDashboard} withLayout={true} />} />
        {/* Bank Approvee */}
         <Route path='/bankapprove' element={<PrivateRoute element={MerchantBankApprove} withLayout={true} />} />

         {/* Rate system */}
          <Route path='/rateset' element={<PrivateRoute element={RateSystem} withLayout={true} />} />

          {/* Upload Invoice */}
          <Route path='/uploadinvoice' element={<PrivateRoute element={UploadInvoice} withLayout={true} />} />
          <Route path='/accountingroledashboard' element={<PrivateRoute element={AccountingRoleDashboard} withLayout={true} />} />


          <Route path='/adadminhistory' element={<PrivateRoute element={OdAdminHistory} withLayout={true} />} />
          <Route path='/lienledger' element={<PrivateRoute element={LienLedger} withLayout={true} />} />
          <Route path='/cdmledger' element={<PrivateRoute element={CdmLedger} withLayout={true} />} />
          <Route path='/cdmhistory' element={<PrivateRoute element={CdmHistory} withLayout={true} />} />
          <Route path='/odoutstanding' element={<PrivateRoute element={OdOutstanding} withLayout={true} />} />
          <Route path='/announcement' element={<PrivateRoute element={Announcement} withLayout={true} />} />
          <Route path='/appversionconfig' element={<PrivateRoute element={AppVersionConfig} withLayout={true} />} />
          {/* <Route path='/txndetails' element={<PrivateRoute element={Txndetails} withLayout={true} />} /> */}
          <Route path='/resetmpin' element={<PrivateRoute element={ResetMpin} withLayout={true} />} />
          <Route path='/dormantuser' element={<PrivateRoute element={DormantUser} withLayout={true} />} />

      </Routes>
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AutoLogout />
        <AppContent />
      </Router>
    </Provider>
  );
}

export default App;